/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Singleregistrationconfirmed2Inputs */

const en__field_singleregistrationconfirmed2 = /** @type {(inputs: _Field_Singleregistrationconfirmed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I confirm that I am only registered once for the Matching Days of UNI:hautnah in the 2026.`)
};

const de__field_singleregistrationconfirmed2 = /** @type {(inputs: _Field_Singleregistrationconfirmed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich bestätige hiermit, dass ich mich im Jahr 2026 nur einmal für die Matching Days von UNI:hautnah angemeldet habe.`)
};

/**
* | output |
* | --- |
* | "I confirm that I am only registered once for the Matching Days of UNI:hautnah in the 2026." |
*
* @param {_Field_Singleregistrationconfirmed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_singleregistrationconfirmed2 = /** @type {((inputs?: _Field_Singleregistrationconfirmed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Singleregistrationconfirmed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_singleregistrationconfirmed2(inputs)
	return de__field_singleregistrationconfirmed2(inputs)
});
export { _field_singleregistrationconfirmed2 as "_field_singleRegistrationConfirmed" }